import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { env } from "./env";
import { initAnalytics, trackPageView } from "./lib/google-analytics";
import { initMetaPixel, trackPixelPageView } from "./lib/meta-pixel";
import { createQueryClient } from "./lib/query-client";
import { routeTree } from "./routeTree.gen";
import "./styles/index.css";

const queryClient = createQueryClient();

const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  scrollRestoration: true,
});

initAnalytics(env.VITE_GA_MEASUREMENT_ID);
initMetaPixel(env.VITE_META_PIXEL_ID);
// Once per finished navigation to a new path (including the first load), not on search-only changes.
router.subscribe("onResolved", ({ pathChanged }) => {
  if (!pathChanged) return;
  trackPageView();
  trackPixelPageView();
});

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

const root = document.getElementById("root");
if (!root) throw new Error("Root element missing");

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
